var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 7.5,13.75 c 3.4518,0 6.25,-2.7982 6.25,-6.25 0,-3.45178 -2.7982,-6.25 -6.25,-6.25 -3.45178,0 -6.25,2.79822 -6.25,6.25 0,3.4518 2.79822,6.25 6.25,6.25 z M 7.5,15 C 11.6421,15 15,11.6421 15,7.5 15,3.35786 11.6421,0 7.5,0 3.35786,0 0,3.35786 0,7.5 0,11.6421 3.35786,15 7.5,15 Z M 8.125,4.375 V 5 6.875 H 10 10.625 v 1.25 H 10 8.125 V 10 10.625 H 6.875 V 10 8.125 H 5 4.375 V 6.875 H 5 6.875 V 5 4.375 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus_circle.c0c24c6ba2efb3ddb5edbc7d8a32ac92.svg";
export { ForwardRef as ReactComponent };